/**
 * Default contributor (credit) roles — the seed for `appConfig/contributorRoles`,
 * which Super Admin can extend. Dependency-free so both the browser
 * (services/app-config.ts re-exports it) and server code (BB Copilot's
 * addContributor) read the same list.
 */
/** Credits that name a place, not a person: no account is ever made for them. */
export const STUDIO_ROLES = ["Recorded At", "Mixed At", "Mastered At"];

export const DEFAULT_CONTRIBUTOR_ROLES: string[] = [
  // Performance
  "Primary Artist", "Featured Artist", "Guest Artist", "Vocalist", "Lead Vocalist",
  "Backing Vocals", "Rapper", "MC", "Emcee", "Singer", "Narrator", "Spoken Word",
  "DJ", "Turntablist", "Performer", "Instrumentalist", "Musician",
  // Songwriting & Composition
  "Songwriter", "Co-Songwriter", "Composer", "Co-Composer", "Lyricist", "Co-Lyricist",
  "Writer", "Co-Writer", "Arranger", "Co-Arranger", "Orchestrator", "Adaptor",
  // Production
  "Producer", "Co-Producer", "Executive Producer", "Associate Producer",
  "Beat Maker", "Beat Producer", "Programmer", "Additional Production",
  "Remixer", "Re-Producer", "Sample Clearance",
  // Engineering
  "Recording Engineer", "Tracking Engineer", "Mixing Engineer", "Mastering Engineer",
  "Assistant Engineer", "Pro Tools Engineer", "Vocal Engineer", "Live Sound Engineer",
  // Studios — company credits, never an account (Gordon 2026-11-03: "at Soundtrade Studios")
  "Recorded At", "Mixed At", "Mastered At",
  // Publishing & Business
  "Publisher", "Sub-Publisher", "Administrator", "Label", "A&R",
  "Manager", "Music Supervisor", "Sync Licensing",
  // Visual / Video
  "Video Director", "Co-Director", "Director of Photography", "Cinematographer",
  "Editor", "Video Editor", "Colorist", "VFX Artist", "Motion Graphics",
  "Photographer", "Artwork", "Graphic Designer", "Art Director",
  // Other
  "Conductor", "Music Director", "Choir Director", "Session Musician", "Other",
];
